// Copyright 2019 The Oppia Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Requires for all the object templates.
 */
require('objects/templates/BooleanEditorDirective.ts');
require('objects/templates/CodeStringEditorDirective.ts');
require('objects/templates/CoordTwoDimEditorDirective.ts');
require('objects/templates/DragAndDropHtmlStringEditorDirective.ts');
require('objects/templates/DragAndDropPositiveIntEditorDirective.ts');
require('objects/templates/FilepathEditorDirective.ts');
require('objects/templates/FractionEditorDirective.ts');
require('objects/templates/GraphEditorDirective.ts');
require('objects/templates/GraphPropertyEditorDirective.ts');
require('objects/templates/HtmlEditorDirective.ts');
require('objects/templates/ImageWithRegionsEditorDirective.ts');
require('objects/templates/IntEditorDirective.ts');
require('objects/templates/ListOfSetsOfHtmlStringsEditorDirective.ts');
require('objects/templates/ListOfTabsEditorDirective.ts');
require('objects/templates/ListOfUnicodeStringEditorDirective.ts');
require('objects/templates/LogicErrorCategoryEditorDirective.ts');
require('objects/templates/LogicQuestionEditorDirective.ts');
require('objects/templates/MathLatexStringEditorDirective.ts');
require('objects/templates/MusicPhraseEditorDirective.ts');
require('objects/templates/NonnegativeIntEditorDirective.ts');
require('objects/templates/NormalizedStringEditorDirective.ts');
require('objects/templates/NumberWithUnitsEditorDirective.ts');
require('objects/templates/ParameterNameEditorDirective.ts');
require('objects/templates/RealEditorDirective.ts');
require('objects/templates/SanitizedUrlEditorDirective.ts');
require('objects/templates/SetOfHtmlStringEditorDirective.ts');
require('objects/templates/SetOfUnicodeStringEditorDirective.ts');
require('objects/templates/UnicodeStringEditorDirective.ts');
